import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col card-main" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Collaborators", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Edit", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "font-semibold ml-4" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "bg-gray-300 p-2 rounded" }
const _hoisted_12 = { class: "text-sm capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_ModalJobMembers = _resolveComponent("ModalJobMembers")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args))),
          class: "flex flex-row items-center btn-outline-sm"
        }, _hoisted_6)
      ]),
      (_ctx.members.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " No members added to this job yet. "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "flex flex-row items-center justify-between mt-8"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Avatar, {
              name: `${member.user.first_name} ${member.user.last_name}`
            }, null, 8, ["name"]),
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("a", {
                href: `mailto:${member.user.email}`
              }, _toDisplayString(member.user.first_name) + " " + _toDisplayString(member.user.last_name), 9, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(member.role), 1)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_ModalJobMembers, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openModal) = $event)),
      jobId: _ctx.jobId,
      onReloadMembers: _ctx.getMembers
    }, null, 8, ["openModal", "jobId", "onReloadMembers"])
  ], 64))
}